import Close from '@mui/icons-material/Close'
import { DialogContent, DialogTitle, IconButton } from '@mui/material'
import { useState } from 'react'
import StyledComponentTabs from 'src/common/tabs/StyledComponentTabs'
import { ALL_GENDERS, EVENT_TYPES_ARRAY } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import DetailComponent from 'src/supportPortal/components/common/bookedEventInfo/components/DetailComponent'
import HistoryComponent from 'src/supportPortal/components/common/bookedEventInfo/components/HistoryComponent'
import { formatEventTimeRange } from 'src/supportPortal/components/common/bookedEventInfo/components/utils'

export default function BookedEventInfoActionDialog({
  bookedEventData,
  closeDialog,
  allSidebarItems,
  switchToReassignMode,
  resetToDefaultMode,
  refreshSlots,
}) {
  const TAB_DETAILS = 'details'
  const TAB_RESCHEDULE = 'reschedule'
  const TAB_CANCEL = 'cancel'
  const TAB_REASSIGN = 'reassign'
  const TAB_HISTORY = 'history'
  const TAB_ARRAY = [
    { title: 'Details', id: TAB_DETAILS },
    // ...(bookedEventData?.status === 'booked' ? [{ title: 'Reschedule', id: TAB_RESCHEDULE }] : []),
    { title: 'History', id: TAB_HISTORY },
    // { label: 'Reassign', value: TAB_REASSIGN },
  ]

  const currentRoom = allSidebarItems?.find((room) => {
    return room?.clinicBrandId === bookedEventData?.clinicBrandId
  })
  const clinicBrand = {
    id: currentRoom?.clinicBrandId,
    title: currentRoom?.clinicBrandName,
  }

  const [selectedTab, setSelectedTab] = useState(TAB_DETAILS)

  // const validMentorList = useMemo(()=>{
  //   const selectedClinic = customOptions?.clinics?.find((clinic) => bookedEventData?.clinicId === clinic?.id)
  //   if(bookedEventData?.eventType === 'therapy-session'){
  //     return [...(selectedClinic?.therapists || []),]
  //   }
  //   return [
  //     ...(selectedClinic?.doctors || []),
  //   ]
  // }, [customOptions, bookedEventData])

  // async function getClinicBrand() {
  //   const resp = await GetSettingsData(GENERIC_APIS.entity.details, {
  //     id: bookedEventData?.clinicBrandId,
  //     entityType: ALL_ENTITY_TYPES_FROM_CONSTANTS.clinicBrand,
  //   })
  //   if (resp.status === 200) {
  //     setClinicBrand(resp.data)
  //   }
  // }

  // useEffect(() => {
  //   if (bookedEventData?.clinicBrandId) {
  //     getClinicBrand()
  //   }
  // }, [bookedEventData])

  const currentEventType = EVENT_TYPES_ARRAY?.find((event) => {
    return event?.id === bookedEventData?.eventType
  })

  return (
    <>
      <DialogTitle>
        <div className="w-100 d-flex flex-column">
          <div className="w-100 fs-6 d-flex justify-content-between align-items-center">
            <span>{formatEventTimeRange(bookedEventData)}</span>
            <div className="d-flex align-items-center gap-1">
              <span>{currentEventType?.title}</span>
              <IconButton onClick={closeDialog}>
                <Close />
              </IconButton>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-center gap-2">
            <span>{bookedEventData?.patientInfo?.patientNumber}</span>
            <strong>{bookedEventData?.patientInfo?.name}</strong>
            <span>
              ({getAgeFromDobWithTime(bookedEventData?.patientInfo?.dateOfBirth)}/
              {
                ALL_GENDERS?.find((gndr) => gndr?.id === bookedEventData?.patientInfo?.gender)
                  ?.title
              }
              )
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <StyledComponentTabs
          tabs={TAB_ARRAY}
          value={selectedTab}
          onChange={(tabVal) => setSelectedTab(tabVal)}
        />
        <div className="mt-1">
          {selectedTab === TAB_DETAILS && (
            <DetailComponent
              bookedEventInfo={bookedEventData}
              clinicBrand={clinicBrand}
              onRescheduleClick={() => {
                switchToReassignMode()
              }}
            />
          )}
          {selectedTab === TAB_HISTORY && (
            <HistoryComponent bookedEventInfo={bookedEventData} clinicBrand={clinicBrand} />
          )}
          {/* {selectedTab === TAB_CANCEL && (
          <CancelComponent
            bookedEventInfo={bookedEventData}
            afterActionFunction={() => {
              refreshViewedItem()
              refreshListing()
            }}
          />
        )} */}
          {/* {selectedTab === TAB_REASSIGN && (
          <ReassignComponent
            bookedEventInfo={bookedEventData}
            mentorList={validMentorList}
            afterActionFunction={() => {
              refreshViewedItem()
              refreshListing()
            }}
          />
        )} */}
        </div>
      </DialogContent>
    </>
  )
}
